import { getFetch, postFetchWithBody, postFetchWithBodyHandler } from "../../utils/fetch";
import Cookies from "js-cookie";
import axios from "axios";

async function storeStop(rows) {
  const res = await postFetchWithBodyHandler('/stop_registrations', {
    stops: rows,
  });
  if (res.status === 200 || res.status === 201) {
    return {
      status: "success",
      message: "توقف با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
const deleteStopRegistration = async (id) => {
  try {
    const token = Cookies.get("login_token");

    if (!token) {
      return {
        status: "error",
        message: "توکنی یافت نشد!",
      };
    }
    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/stop_registrations/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    });

    console.log(response.data.message);
    return true;
  } catch (error) {
    if (error.response?.status === 404) {
      console.error('رکورد پیدا نشد.');
    } else {
      console.error('خطا در حذف:', error.message);
    }
    return false;
  }
};

async function downloadAllReport() {
  const data = await getFetch('/ReportWeb/Reports/download-report-stop-registration');
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { storeStop , deleteStopRegistration,downloadAllReport};

